import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function processoSeletivo() {
	const api = useApi()

	async function getProcessoSeletivo() {
		return api.query(`${window.origin}${URLS.processo_seletivo}`)
	}

	async function createProcessoSeletivo(data) {
		return api.mutation(
			`${window.origin}${URLS.processo_seletivo}`,
			'post',
			data
		)
	}

	async function deleteProcessoSeletivo(id) {
		return api.mutation(
			`${window.origin}${URLS.processo_seletivo}${id}/`,
			'delete'
		)
	}

	return {
		getProcessoSeletivo,
		createProcessoSeletivo,
		deleteProcessoSeletivo,
		...api,
	}
}
